lmApp
  .service('EpgService', ['$rootScope', '$q',
    function ($rootScope, $q) {

      var service = {};

      service.GetEpgEvents = function (epg, day) {
        var deferred = $q.defer();

        var data = {
          channelIds: [epg.id],
          startTime: day.start,
          duration: day.end - day.start
        };

        lh.epg.getEvents(data)
          .then(function (collection) {
            deferred.resolve(collection);
          }, function (reason) {
            reason.url = 'lh.epg.getEvents';
            reason.data = data;
            deferred.reject(reason)
          });

        return deferred.promise;
      };

      service.GetPoster = function (event) {
        var deferred = $q.defer();

        lh.models.epgEvent.methods.getPosterUrl(event)
          .then(function (url) {
            deferred.resolve(url);
          }, function (reason) {
            deferred.reject(reason);
          });

        return deferred.promise;
      };

      service.GetEpgSources = function () {
        var deferred = $q.defer();

        var url = 'collection/epg.source/query';

        lh.common.request(url)
          .then(function (response) {
            deferred.resolve(response.collection);
          })
          .catch(function (reason) {
            reason.url = url;
            reason.data = 'GET';
            deferred.reject(reason);
          });

        return deferred.promise;
      };

      service.GetEpgImportTasks = function (id) {
        var deferred = $q.defer();

        var url = 'collection/epg.import/query';

        if (id) url += '/dimension/source_id/eq/' + id;

        lh.common.request(url)
          .then(function (response) {
            deferred.resolve(response.collection);
          })
          .catch(function (reason) {
            reason.url = url;
            reason.data = 'GET';
            deferred.reject(reason);
          });

        return deferred.promise;
      };

      service.CreateNewEpgSource = function (source) {
        var deferred = $q.defer();

        var url = 'epg/import/source/create';

        var data = {
          url: source.url
        };

        if (source.name) data.name = source.name;

        lh.common.request.post(url, data)
          .then(function (response) {
            deferred.resolve(response);
          })
          .catch(function (reason) {
            reason.url = url;
            reason.data = data;
            deferred.reject(reason);
          });

        return deferred.promise;
      };

      service.CreateEpgImportTask = function (source, task, channels) {
        var deferred = $q.defer();

        var url = 'epg/import/schedule';

        var data = {
          source_id: source.id,
          epg_channel_ids: channels.join(','),
          schedule_time: task._PrivateData.schedule_time,
          force_now: 1
        };

        if (task.name) data.name = task.name;

        lh.common.request.post(url, data)
          .then(function (response) {
            deferred.resolve(response);
          })
          .catch(function (reason) {
            reason.url = url;
            reason.data = data;
            deferred.reject(reason);
          });

        return deferred.promise;
      };

      service.UpdateEpgImportTask = function (source, task, channels) {
        var deferred = $q.defer();

        var url = 'epg/import/schedule/update';

        var data = {
          schedule_id: task.id,
          source_id: source.id,
          epg_channel_ids: channels.join(','),
          schedule_time: task._PrivateData.schedule_time,
          is_active: +task.is_active,
          force_now: 1
        };

        if (task.name) data.name = task.name;

        lh.common.request.post(url, data)
          .then(function (response) {
            deferred.resolve(response);
          })
          .catch(function (reason) {
            reason.url = url;
            reason.data = data;
            deferred.reject(reason);
          });

        return deferred.promise;
      };

      service.DeleteEpgImport = function (source) {
        var deferred = $q.defer();

        var url = 'epg/import/source/remove';

        var data = {
          source_id: source.id
        };

        lh.common.request.post(url, data)
          .then(function (response) {
            deferred.resolve(response);
          })
          .catch(function (reason) {
            reason.url = url;
            reason.data = data;
            deferred.reject(reason);
          });

        return deferred.promise;
      };

      return service;
    }]);
